import { AppRoutes } from '@consts/routes';
import { Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useQuery } from '@hooks/useQuery';
import { TicketContainer } from '../TicketContainer';
import { LandingEffects } from './LandingEffects';
import { Button } from '@components/design-system/components/Button/Button';
import { colors, typography, spacing } from '@components/design-system/tokens';

export const TicketsLanding = () => {
  const navigate = useNavigate();
  const query = useQuery();

  return (
    <TicketContainer>
      <LandingEffects />

      <Box sx={{ textAlign: 'center' }}>
        <Typography sx={{
          fontFamily: typography.fontFamily.display,
          fontSize: { xs: typography.fontSize.xl, sm: typography.fontSize['2xl'] },
          fontWeight: typography.fontWeight.semibold,
          color: colors.neutral[900],
          mb: `${spacing.xs}px`,
        }}>
          Need help?
        </Typography>
        <Typography sx={{
          fontSize: { xs: typography.fontSize.sm, sm: typography.fontSize.base },
          color: colors.neutral[500],
        }}>
          Select an option below to get started.
        </Typography>
      </Box>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: `${spacing.sm}px` }}>
        <Button
          variant="outline"
          size="large"
          fullWidth
          onClick={() => window.open('https://www.moutfitters.com/rapidcut-training-mini/', '_blank')}
        >
          Training Resources
        </Button>

        <Button
          variant="outline"
          size="large"
          fullWidth
          onClick={() => window.open('https://zingtree.com/live/568949117', '_blank')}
        >
          Self Troubleshoot
        </Button>

        <Button
          variant="primary"
          size="large"
          fullWidth
          onClick={() => navigate(`${AppRoutes.TicketForm}?${query.toString()}`)}
        >
          Open a Ticket
        </Button>
      </Box>
    </TicketContainer>
  );
};
